import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const palette = clientThemePalette[CLIENT_THEME].light;

export const colorMap: Record<string, React.CSSProperties> = {
  // actions
  Preventive: { backgroundColor: '#FFA4031A', color: '#FFA403' },
  Corrective: { backgroundColor: '#EB57571A', color: '#EB5757' },
  Inspect: { backgroundColor: '#0091611A', color: '#009161' },

  // priority
  Low: { backgroundColor: '#009161', color: '#FFFFFF' },
  Medium: { backgroundColor: '#FFA403', color: '#FFFFFF' },
  High: { backgroundColor: '#EB5757', color: '#FFFFFF' },
  // status
  open: { backgroundColor: palette.primary, color: '#FFFFFF' },
  'in progress': { backgroundColor: '#FFA403', color: '#FFFFFF' },
  completed: { backgroundColor: '#009161', color: '#FFFFFF' },
  // others
  'Part Repaired': {
    backgroundColor: 'rgba(13, 110, 253, 0.2)',
    color: '#0d6efd',
  },
  'Part Replaced': { backgroundColor: '#009161', color: '#FFFFFF' },
  None: {},
};
